export interface WordPressTranslation {
  key: string;
  value: string;
}

export const findWordPressTranslation = (
  translations: WordPressTranslation[],
  translationKey: string
): string | null => {
  if (!translations || translations.length === 0) return null;

  const translation = translations.find(({ key }) => key === translationKey);
  const foundTranslation = translation ? translation.value : null;
  return foundTranslation;
};
